module.exports = __webpack_public_path__ + "media/images/orion_pictos/orion-customer-support-3f3a196bdd2aa6fda31d1c7b90b57746.svg";